import {ID, Response} from '../../../../../../_metronic/helpers'
export type User = {
  id?: ID
  name?: string
  avatar?: string
  email?: string
  type?: string
  level?: string
  password?: string
  initials?: {
    label: string
    state: string
  }
  categories?: Category[]
}

export type UsersQueryResponse = Response<Array<User>>

export const initialUser: User = {
  avatar: '',
  type: 'admin',
  level: '',
  name: '',
  email: '',
  password: '',
  id: '',
}

export type Category = {
  code?: string
  name?: string
}

export type CategoryQueryResponse = Response<Array<Category>>
